<template>
    <b-row>
        <b-col lg="12">
            <div>
                <h3>สิ่งที่ต้องทำ</h3>
            </div>
            <b-list-group class="daliy-task">
                <b-list-group-item
                    class="d-flex justify-content-between align-items-center py-3"
                    href="javascript:;"
                    role="tab"
                    :class="visibleCamera ? null : 'collapsed'"
                    :aria-expanded="visibleCamera ? 'true' : 'false'"
                    aria-controls="cameraPhoto"
                    @click="$emit('handleClickDailyPhotos')"
                >
                    <span class="h3 d-flex align-items-center">
                        ถ่ายเครื่องแบบประจำวัน
                        <i
                            class="fa fa-check-circle text-primary pl-2"
                            v-if="todoList.dailyPhotos"
                        ></i>
                    </span>
                    <i class="ni ni-bold-down" v-if="visibleCamera"></i>
                    <i class="ni ni-bold-right" v-else></i>
                </b-list-group-item>
                <b-collapse
                    id="cameraPhoto"
                    v-model="visibleCamera"
                    accordion="my-accordion"
                    role="tabpanel"
                >
                    <b-card>
                        <b-card-body class="p-0">
                            <img
                                v-if="todoList.dailyPhotos && todoList.showdailyPhoto"
                                :src="todoList.dailyPhotosURL"
                                width="100%"
                                height="100%"
                                alt="DailyPhotos"
                                class="cursor-pointer"
                                @click="openModalDisplayImage()" 
                            />
                            <div
                                v-else
                                class="btn-camera d-flex justify-content-center align-items-center cursor-pointer"
                                @click="openModalCarema()"
                            >
                                <div class="text-center">
                                    <b-icon icon="camera" font-scale="4"></b-icon>
                                    <p>กดเพื่อถ่ายรูปเครื่องแบบ</p>
                                </div>
                            </div>
                            <OpenCamera
                                ref="openCamera"
                                :todoList="todoList"
                                @onSavePicture="onSavePicture" 
                            />
                        </b-card-body>
                    </b-card>
                </b-collapse>
                <!-- Modal for displaying full screen image -->
                <DisplayImage :url="todoList.dailyPhotosURL" />
            </b-list-group>
        </b-col>
    </b-row>
</template>

<script>
import empoyeeServices from "@/api/empoyee.service.js";
import OpenCamera from "@/components/Modal/Image/OpenCamera.vue";
import DisplayImage from "@/components/Modal/Image/DisplayImage.vue";

export default {
    components: { DisplayImage, OpenCamera },
    props: {
        todoList: {
            type: Object,
            default: () => {}
        },
        visibleCamera: {
            type: Boolean
        },
        isLoadPage: {
            type: Boolean
        }
    },
    methods: {
        openModalCarema() {
            this.$bvModal.show("upload-camera");
        },
        openModalDisplayImage() {
            this.$bvModal.show("display-image");
        },
        async onSavePicture(photo) {
            try {
                this.$emit('update:isLoadPage', true);
                const response = await empoyeeServices.uploadDriverClothes(photo);

                this.$refs.openCamera.$refs.cameraComponent.closeCamera();
                this.$refs.openCamera.$refs.cameraComponent.resetComponent();
                this.$bvModal.hide("upload-camera");

                await this.$emit('getDailyPhotosDriver');
            } catch (error) {
                console.error("Error saving picture:", error);
            }finally{ this.$emit('update:isLoadPage', false); }
        },
    },
}
</script>
